import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import useTrans from '../../hooks/useTrans';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getListProjectWeb } from '../../redux/actions/project';
import _ from 'lodash';

import MetaSeo from '../MetaSeo';
export default function Project(props) {
  useEffect(() => {
    // if (props.match.params.id) {
    //     getDetail(props.match.params.id);
    // }
    setRows(props.rows);
    setTotal(props.total);
    setPage(props.page);
    setDataField(props.data_field?.data);
    setDataLanguage(props.data_language?.data);
  }, [props]);
  const [rows, setRows] = useState(props.rows || []);

  const [total, setTotal] = useState(props.total || null);
  const [page, setPage] = useState(props.page || 1);
  const [limit, setLimit] = useState(props.limit || 10);
  const [search, setSearch] = useState(null);
  const [is_search, setIsSearch] = useState(false);
  const dispatch = useDispatch();
  const trans = useTrans();
  const [data_field, setDataField] = useState(props.data_field?.data || []);
  const [data_language, setDataLanguage] = useState(
    props.data_language?.data || [],
  );
  const [array_tag_id, setArrayTagId] = useState([]);
  const filterTag = async tag_id => {
    if (array_tag_id.length && array_tag_id.includes(tag_id)) {
      let tag_array = array_tag_id.filter(it => it !== tag_id);
      setArrayTagId(tag_array);
      const data = await getListProjectWeb(
        { tag_id: tag_array, name: search?.trim() },
        dispatch,
      );
      if (data) {
        setRows(data.rows);
        setTotal(data.total);
        setPage(data.page);
      }
    } else {
      let tag_array = [...array_tag_id];
      tag_array.push(tag_id);
      setArrayTagId(tag_array);
      const data = await getListProjectWeb(
        { tag_id: tag_array, name: search?.trim() },
        dispatch,
      );
      if (data) {
        setRows(data.rows);
        setTotal(data.total);
        setPage(data.page);
      }
    }
  };
  const filterOneTag = async tag_id => {
    let tag_array = [];
    tag_array.push(tag_id);
    const data = await getListProjectWeb(
      { tag_id: tag_array, name: search },
      dispatch,
    );
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
      setPage(data.page);
    }
  };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getListProjectWeb(
      { page: new_page, limit, tag_id: array_tag_id },
      dispatch,
    );
    if (data) {
      const new_data = [...rows, ...data.rows];
      setRows(new_data);
    }
  };
  const onSearch = async () => {
    let data = await getListProjectWeb(
      { page: 1, limit, name: search.trim(), tag_id: array_tag_id },
      dispatch,
    );
    setIsSearch(true);
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
    }
  };
  const onSearchDelay = _.debounce(() => onSearch(), 100);
  const onEnterkey = e => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  const dataFilter = {
    field: [
      {
        id: 1,
        name: 'Video Streaming',
      },
      {
        id: 2,
        name: 'Social',
      },
      {
        id: 3,
        name: 'E-learning',
      },
      {
        id: 4,
        name: 'Buildings',
      },
      {
        id: 5,
        name: 'All',
      },
      {
        id: 6,
        name: 'Cloud Camera',
      },
      {
        id: 7,
        name: 'Realtime',
      },
      {
        id: 8,
        name: 'Blockchain',
      },
      {
        id: 9,
        name: 'E-School',
      },
      {
        id: 10,
        name: 'Backend',
      },
    ],
    languages: [
      {
        id: 1,
        name: 'Web',
      },
      {
        id: 2,
        name: 'App',
      },
      {
        id: 3,
        name: 'HR system',
      },
      {
        id: 4,
        name: 'HTML',
      },
      {
        id: 5,
        name: 'Java',
      },
      {
        id: 6,
        name: 'C# (C#-Sharp)',
      },
      {
        id: 7,
        name: 'JavaScript',
      },
      {
        id: 8,
        name: 'PHP',
      },
      {
        id: 9,
        name: 'Python',
      },
      {
        id: 10,
        name: 'C/C++',
      },
      {
        id: 11,
        name: 'Ruby',
      },
      {
        id: 12,
        name: 'Swift',
      },
      {
        id: 13,
        name: 'C#',
      },
    ],
  };

  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: 'Project | TCOM Global',
    description: 'Our noteworthy projects to the delight of our clients',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
    card: 'summary_large_image',
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="main-content">
        <div className="r-big-banner">
          <div className="r-page-title">
            <div className="container">
              <h3>{trans?.project?.feature_project}</h3>
              <p>{trans?.project?.feature_project_description}</p>
              <p>{trans?.project?.feature_project_description1}</p>
            </div>
          </div>
        </div>

        <div className="r-top jenabfbqwbwb">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                {/* <div className="p-project-tt">
                  <div className="p-home__our-service-title p-project-service-title ">
                    <h1>{trans?.project.feature_project}</h1>
                    <div className="oadisjdh22">
                      <div
                        className="p-project-title-service-abc  p-project-title-service-abc-dt"
                        dangerouslySetInnerHTML={{
                          __html: trans?.project.feature_project_description_3,
                        }}
                      ></div>

                      <div className="p-project-title-service-abc p-project-title-service-abc-mb ">
                        <p>{trans?.project?.feature_project_description_4}</p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="col-12 col-md-6">
                <div className="search">
                  <input
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                    type="text"
                    placeholder={trans?.project?.search}
                    onKeyDown={onEnterkey}
                  />
                  <button type="submit" onClick={onSearchDelay}>
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z"
                        stroke="#A7A7A7"
                        strokeWidth={2}
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {rows.length ? (
          <div className="r-project-list">
            <div className="container">
              <div className="row dahqwuyaydaw">
                {rows.map(item => {
                  return (
                    <div className="col-12 col-md-6">
                      <a href={`/project/${item.seo_url}`} className="image">
                        <img src={item.background_image} alt="" />
                      </a>
                      <div className="content">
                        <a href={`/project/${item.seo_url}`} className="title">
                          {item.name}
                        </a>
                        <ul className="tag">
                          {item.project_hook_tag.map(it => {
                            return (
                              <li>
                                <a // onClick={() => filterOneTag(it?.project_tag?.id)}
                                >
                                  {it?.project_tag?.name}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                        <p className="desc" title={item.description}>
                          {item.description}
                        </p>
                        <a
                          href={`/project/${item.seo_url}`}
                          className="readmore"
                        >
                          {trans.text_button.read_more}
                          <img src="/assets/img/slider/next-solid.svg" alt="" />
                        </a>
                      </div>
                    </div>
                  );
                })}
                {rows.length < total ? (
                  <div className="text-center">
                    <a onClick={() => loadMore()} className="see-more">
                      {trans.text_button.read_more_b}
                    </a>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        ) : (
          <div id="not-found">
            <div className="main-content">
              <div className="container">
                <div className="inner">
                  <div className="image">
                    <img src="/assets/images/404-search.png" alt="" />
                  </div>
                  <h3>{trans?.project?.no_result}</h3>
                  <a href="/" className="btn-back">
                    {trans?.project?.back_home}
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
